import { filter, addIndex, curry, contains } from 'ramda';

// helpers
var filterIndexed = /*#__PURE__*/addIndex(filter);
var containsIndex = /*#__PURE__*/curry(function (indexes, val, index) {
  return contains(index, indexes);
});

/**
 * Picks values from list by indexes.
 *
 * @func pickIndexes
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.1.0|v1.1.0}
 * @category List
 * @sig  [Number] -> [a] -> [a]
 * @param {Array} indexes The indexes to pick
 * @param {Array} list The list to pick values from
 * @return {Array} New array containing only values at `indexes`
 * @see {@link http://ramdajs.com/docs/#pick|pick}, {@link RA.omitIndexes|omitIndexes}
 * @example
 *
 * RA.pickIndexes([0, 2], ['a', 'b', 'c']); //=> ['a', 'c']
 */
var pickIndexes = /*#__PURE__*/curry(function (indexes, list) {
  return filterIndexed(containsIndex(indexes), list);
});

export default pickIndexes;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/pickIndexes.js
// module id = 774
// module chunks = 0